webpackJsonp([273950069227526],{

/***/ 485:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mono2Ski","author":"Lawrence Gosset"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-f75c4389fb97724478a1.js